export default "__VITE_ASSET__B6ZQfj5c__"